import { useEffect } from 'react';
import { history } from '../../../../../redux';

/**
 * Handles automatic post-payment redirects:
 * - External URL (MP / init_point) → opens tab and redirects to campaign
 * - Payment successfully created → redirects to campaign
 */
const usePaymentRedirects = ({ paymentData, creatingPayment, creatingCampaign, campaign }) => {
  useEffect(() => {
    if (!paymentData || !campaign) return;
    if (paymentData.external_resource_url || paymentData.init_point) {
      window.open(paymentData.external_resource_url || paymentData.init_point);
      history.push(`/campaign/${campaign.id}`);
    }
  }, [paymentData]);

  useEffect(() => {
    if (!creatingPayment && !creatingCampaign && paymentData && paymentData.id && campaign) {
      history.push(`/campaign/${campaign.id}`);
    }
  }, [creatingPayment, paymentData]);
};

export default usePaymentRedirects;
